// [ai] The rail's resize grip on its border: drag ±20 % (192–288), far left collapses; the width is written on release only.
// The drag origin lives in a ref: every store update re-renders this component, so a plain variable would forget it mid-drag.
import { useRef } from "react";
import { useShell, useShellStore } from "../stores/shell";

export function Grip() {
  const store = useShellStore(); const dragWidth = useShell(s => s.dragWidth); const endDrag = useShell(s => s.endDrag);
  const start = useRef<{ x: number; w: number } | null>(null);
  const end = () => { start.current = null; endDrag(); };
  return (
    <div className="at-side-grip" id="side-grip" role="separator" aria-orientation="vertical" aria-label="Resize the sidebar" title="Drag to resize · drag left to collapse"
      onPointerDown={e => { if (e.button) return; e.preventDefault(); e.currentTarget.setPointerCapture(e.pointerId); start.current = { x: e.clientX, w: store.getState().side.w }; }}
      onPointerMove={e => { if (start.current) dragWidth(start.current.w + e.clientX - start.current.x); }}
      onPointerUp={end} onPointerCancel={end} />
  );
}
